import Keycloak from "keycloak-js";

export const keycloak = Keycloak<"native">({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM || "OGC-audit",
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "ogc-audit-client",
});
